<template>
  <div class="bank-card bg-white">
    <div class="notice">
      {{ $t('PersonalCenter.Payment.BankCard.Tips1') }}
    </div>
    <div class="card-main">
      <div class="card-add">
        <div class="card f-c-c fd-c" @click="addCard">
          <div><i class="el-icon-plus avatar-uploader-icon"></i></div>
          <div>{{ $t('PersonalCenter.Payment.BankCard.AddANewCard') }}</div>
        </div>
      </div>
      <div v-for="(item, i) in list" :key="item.id" class="card-box">
        <div class="card" :class="{ 'card-activity': i === 0 }">
          <img :src="cardIcon(item.card.brand)" style="width:60px" alt="">
          <div class="num">
            **** **** **** {{ item.card.last4 }}
          </div>
          <div v-if="i === 0" class="default-icon">
            <i class="el-icon-check"></i>
          </div>
        </div>
        <div class="card-bottom">
          <el-radio :value="i===0" :label="true" @change="e => changeDefault(e, item.id)">
            {{ i===0 ? 'Default' : 'Set as default' }}
          </el-radio>
          <div class="pointer" @click="handleRemove(item.id)">{{ $t('PersonalCenter.Payment.BankCard.Remove') }}</div>
        </div>
      </div>
    </div>

    <airwallex-card ref="airwallexCard" @success="getPaymentPaymentConsent()" />
  </div>
</template>

<script>

import AirwallexCard from './components/AirwallexCard.vue'
import API from '@/api'

export default {
  components: { AirwallexCard },
  data() {
    return {
      radio: 1,
      list: []
    }
  },
  created() {
    this.getPaymentPaymentConsent()
  },
  methods: {
    cardIcon(brand) {
      if (brand === 'visa') {
        return require('@/assets/img/productDetail/card_1.png')
      }
      if (brand === 'mastercard') {
        return require('@/assets/img/productDetail/card_2.png')
      }
      if (brand === 'american express') {
        return require('@/assets/img/productDetail/card_4.png')
      }
      return ''
    },
    getPaymentPaymentConsent() {
      API.getPaymentPaymentConsent().then(res => {
        if (res.code !== 10000) return this.$message.error(res.message)
        this.list = res.data
      })
    },
    addCard() {
      this.$refs.airwallexCard.show()
    },
    changeDefault(e, id) {
      console.log(e, id)
      API.sortPaymentPaymentConsent(id).then(res => {
        if (res.code !== 10000) return this.$message.error(res.message)
        this.$message.success(res.message)
        this.getPaymentPaymentConsent()
      })
    },
    handleRemove(id) {
      this.$confirm(`${this.$t('PersonalCenter.Payment.BankCard.Tips2')}`, {
        confirmButtonText: `${this.$t('PersonalCenter.Payment.BankCard.Confirm')}`,
        cancelButtonText: `${this.$t('PersonalCenter.Payment.BankCard.Cancel')}`,
        type: 'warning'
      }).then(() => {
        this.deletePaymentPaymentConsent(id)
      })
    },
    deletePaymentPaymentConsent(id) {
      API.deletePaymentPaymentConsent(id).then(res => {
        if (res.code !== 10000) return this.$message.error(res.message)
        this.$message.success(res.message)
        this.getPaymentPaymentConsent()
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.bank-card {
  .notice {
    background: rgba(153, 196, 28, 0.04);
    padding: 30px 20px;
  }

  .card-main {
    padding: 20px 30px;
    padding-right: 0;
    display: flex;
    flex-wrap: wrap;

    .card {
      border: 1px solid #CDD4DD;
      border-radius: 6px;
      height: 160px;
      padding: 26px 24px;
      position: relative;

      .num {
        font-size: 24px;
        font-family: 'Alte DIN 1451 Mittelschrift gepraegt';
        font-weight: 600;
        margin-top: 10px;
      }

      .avatar-uploader-icon {
        font-size: 20px;
        margin-bottom: 10px;
      }

      .default-icon {
        width: 29px;
        height: 29px;
        border-radius: 0 6px 0 29px;
        background: #99c41c;
        position: absolute;
        top: 0;
        right: 0;
        font-size: 20px;
        color: #fff;
        padding: 0 6px;
      }
    }
    .card-add, .card-box {
      height: 200px;
      width: 30%;
      margin-right: 30px;
      min-width: 280px;
    }
    .card-add {
      display: f;
    }
    .card-box {
      .card-bottom {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-top: 10px;

        /deep/ .el-radio {
          padding: 0;
        }
      }
    }
    .card-activity{
      background-color: #FBFDF6;
      border:1px solid #99C41C;
    }
  }
}
</style>
